'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBooksCategory = exports.IconBookOpenBookmark = exports.IconBookOpen = exports.IconUser = exports.IconZoomOut = exports.IconWarehouseCartPackages2 = exports.IconWarehouseCartPackage = exports.IconZoomIn = exports.IconWarehousePackages = exports.IconView = exports.IconViewOff = exports.IconVideoPlayerMovieAlt = exports.IconViewColumn = exports.IconVectorsAnchorSquareAlt = exports.IconUserSetting = exports.IconUserPhoneBook = exports.IconUserLock = exports.IconUserAlt = exports.IconUserActionsRemove = exports.IconUploadBottom = exports.IconUndo = exports.IconTruckConfigure = exports.IconTruckCargo = exports.IconTopOfRow = exports.IconTimeStopwatch = exports.IconTimeClockCircle = exports.IconTextBold = exports.IconTextUnderline = exports.IconTextStrikeThrough = exports.IconTextItalic = exports.IconTaskListWarning = exports.IconTapCheck = exports.IconTagDollarAlt = exports.IconSynchronizeArrowsAlt = exports.IconSynchronizeArrowClock = exports.IconSmallFormatCategory = exports.IconStartPriceList = exports.IconStartContract = exports.IconShoppingCartFull = exports.IconShoppingCartAlt = exports.IconShoppingBasketAlt = exports.IconShoppingBasketAdd = exports.IconShop = exports.IconShipmentUploadAlt = exports.IconShirtPlain = exports.IconShipmentTruck = exports.IconShipmentPlane = exports.IconShipmentPackages = undefined;
exports.IconShipmentGive = exports.IconShipmentCheck = exports.IconShipmentCash = exports.IconShipmentBox = exports.IconShareAlt = exports.IconSettingsToggleHorizontal = exports.IconSettingsVertical = exports.IconSettingsSlider = exports.IconSearch = exports.IconSearchStar = exports.IconRuler = exports.IconRoadSignBanned = exports.IconRightOfColumn = exports.IconRemove = exports.IconRemoveRow = exports.IconRemoveColumn = exports.IconRemoveCircle = exports.IconRedo = exports.IconReceiptRegisterPrint = exports.IconReceiptDollar = exports.IconRatingStarAlt = exports.IconRatingStar = exports.IconQuoter = exports.IconQuoterRecommendations = exports.IconQuestionCircle = exports.IconPromoProductsCategory = exports.IconProductsBriefcase = exports.IconProductPricingTerms = exports.IconPrintPicture = exports.IconPinLocationAlt = exports.IconPin = exports.IconPictureSun = exports.IconPicturePolaroidLandscape = exports.IconPicturePolaroidAlbumAlt = exports.IconPictureFlowerAlt = exports.IconPerformanceIncreaseAlt = exports.IconPencilCircle = exports.IconPencilAlt = exports.IconParagraphRightAlign = exports.IconParagraphLeftAlign = exports.IconParagraphCenterAlign = exports.IconPackageCategory = exports.IconOfficeFileXls = exports.IconOfficeFilePdf = exports.IconNetworkPin = exports.IconNumeric = exports.IconNewspaper = exports.IconNavigationNext = exports.IconMultipleUsers = exports.IconNavigationMenu = exports.IconNavigationMenuVertical = exports.IconMessagesPeopleUserDollar = exports.IconMonitorAlt = exports.IconMultipleActionsRemove = exports.IconMonitorShoppingCart = exports.IconMessagesBubble = exports.IconMessagesBubbleQuestion = exports.IconMessagesBubbleInformation = exports.IconLockUnlock = exports.IconLockAlt = exports.IconLoadingHalf = exports.IconLoadingCircleAlt = exports.IconListBullets = exports.IconLeftOfColumn = exports.IconLayoutModule = exports.IconLayers = exports.IconLayoutDashboard = exports.IconLayersFront = exports.IconLayersBack = exports.IconLargeFormatCategory = exports.IconIrisScanLock = exports.IconInformationCircle = exports.IconImageFileSettings = exports.IconImageFileEdit = exports.IconImageFileAdd = exports.IconIdCard = exports.IconHyperlink = exports.IconHouse = exports.IconHierarchyNode = exports.IconHierarchyFlow = exports.IconGridGuides = exports.IconGiftsCategory = exports.IconGaugeDashboard = exports.IconFulfillerCreate = exports.IconFolderCode = exports.IconFolderImage = exports.IconFocusLandscape = exports.IconFloppyDiskAlt = exports.IconFinalizePriceList = exports.IconFinalizeContract = exports.IconFilterAlt = exports.IconFileCode = exports.IconFactory = exports.IconExpandDiagonal2 = exports.IconExpand5 = exports.IconEmailSend = exports.IconEmailActionUnread = exports.IconEmailActionCash = exports.IconEarthAlt = exports.IconEarth3 = undefined;
exports.IconDrop = exports.IconDrawerOpen = exports.IconDrawerFile = exports.IconDragVertical = exports.IconDragHorizontial = exports.IconDeliveryTruckBoxes = exports.IconDeliveryParachute = exports.IconDataTransferHorizontal = exports.IconDragDrop = exports.IconDownloadBottom = exports.IconDiscount = exports.IconDirectionButtonArrows = exports.IconDesktopMonitorApprove = exports.IconDesignWarpPerspective = exports.IconDesignWarpCylinder = exports.IconDesignToolPenStation = exports.IconDeliveryTruckClock = exports.IconDeliveryTruck2 = exports.IconCurrencyEuroDollarExchange = exports.IconCopy = exports.IconCopyPaste = exports.IconConversationChatAlt = exports.IconControlsPlay = exports.IconConfigureTemplate = exports.IconCompassAlt = exports.IconCompare = exports.IconCommonFileText = exports.IconCommonFileStack = exports.IconColorPicker3 = exports.IconColorPaintingPalette = exports.IconColorBucket = exports.IconColorBucketAlt = exports.IconCog = exports.IconCogDouble = exports.IconCogApproved = exports.IconCloudUpload = exports.IconClose = exports.IconChecklist = exports.IconCheck = exports.IconCheckSquare = exports.IconCheckCircleAlt = exports.IconCheckBadge = exports.IconChargerAlt = exports.IconCashEye = exports.IconCap2 = exports.IconCalendar = exports.IconCalendarPlane = exports.IconCalendarHome = exports.IconButtonStop = exports.IconButtonPause = exports.IconBusinessDealCashExchange = exports.IconBusinessContractHandshakeSign = exports.IconBottomOfRow = exports.IconBin = exports.IconBarcode = exports.IconBagsCategory = exports.IconAttachment = exports.IconArtboardShrink = exports.IconArrowUp = exports.IconArrowUpAlt = exports.IconArrowThickUp = exports.IconArrowThickRight = exports.IconArrowThickLeft = exports.IconArrowThickDown = exports.IconArrowRight = exports.IconArrowRightAlt = exports.IconArrowLeft = exports.IconArrowLeftAlt = exports.IconArrowDown = exports.IconArrowDownAlt = exports.IconApparelCategory = exports.IconArrowCircleUp = exports.IconArrowCircleRight = exports.IconArrowCircleLeft = exports.IconArrowCircleDown = exports.IconArrowButtonUp = exports.IconArrowButtonUp2 = exports.IconArrowButtonRight = exports.IconArrowButtonRight2 = exports.IconArrowButtonLeft = exports.IconArrowButtonLeft2 = exports.IconArrowButtonDown = exports.IconArrowButtonDown2 = exports.IconAppWindowSearchAlt = exports.IconAppWindowNext = exports.IconAppWindowLayout = exports.IconAngleBrackets = exports.IconAnalyticsPieAlt = exports.IconAnalyticsGraph = exports.IconAlarmBell = exports.IconAlertTriangle = exports.IconAlarmBellOff = exports.IconAdd = exports.IconAddSquare = exports.IconAddProduct = exports.IconAccountingDocument = exports.IconAddCircle = exports.IconAccountingCoinsBill = exports.IconAccountingCalculator = exports.IconAccountingCalculatorAlt = undefined;

var _IconAccountingCalculatorAlt = require('./IconAccountingCalculatorAlt.js');

var _IconAccountingCalculatorAlt2 = _interopRequireDefault(_IconAccountingCalculatorAlt);

var _IconAccountingCalculator = require('./IconAccountingCalculator.js');

var _IconAccountingCalculator2 = _interopRequireDefault(_IconAccountingCalculator);

var _IconAccountingCoinsBill = require('./IconAccountingCoinsBill.js');

var _IconAccountingCoinsBill2 = _interopRequireDefault(_IconAccountingCoinsBill);

var _IconAddCircle = require('./IconAddCircle.js');

var _IconAddCircle2 = _interopRequireDefault(_IconAddCircle);

var _IconAccountingDocument = require('./IconAccountingDocument.js');

var _IconAccountingDocument2 = _interopRequireDefault(_IconAccountingDocument);

var _IconAddProduct = require('./IconAddProduct.js');

var _IconAddProduct2 = _interopRequireDefault(_IconAddProduct);

var _IconAddSquare = require('./IconAddSquare.js');

var _IconAddSquare2 = _interopRequireDefault(_IconAddSquare);

var _IconAdd = require('./IconAdd.js');

var _IconAdd2 = _interopRequireDefault(_IconAdd);

var _IconAlarmBellOff = require('./IconAlarmBellOff.js');

var _IconAlarmBellOff2 = _interopRequireDefault(_IconAlarmBellOff);

var _IconAlertTriangle = require('./IconAlertTriangle.js');

var _IconAlertTriangle2 = _interopRequireDefault(_IconAlertTriangle);

var _IconAlarmBell = require('./IconAlarmBell.js');

var _IconAlarmBell2 = _interopRequireDefault(_IconAlarmBell);

var _IconAnalyticsGraph = require('./IconAnalyticsGraph.js');

var _IconAnalyticsGraph2 = _interopRequireDefault(_IconAnalyticsGraph);

var _IconAnalyticsPieAlt = require('./IconAnalyticsPieAlt.js');

var _IconAnalyticsPieAlt2 = _interopRequireDefault(_IconAnalyticsPieAlt);

var _IconAngleBrackets = require('./IconAngleBrackets.js');

var _IconAngleBrackets2 = _interopRequireDefault(_IconAngleBrackets);

var _IconAppWindowLayout = require('./IconAppWindowLayout.js');

var _IconAppWindowLayout2 = _interopRequireDefault(_IconAppWindowLayout);

var _IconAppWindowNext = require('./IconAppWindowNext.js');

var _IconAppWindowNext2 = _interopRequireDefault(_IconAppWindowNext);

var _IconAppWindowSearchAlt = require('./IconAppWindowSearchAlt.js');

var _IconAppWindowSearchAlt2 = _interopRequireDefault(_IconAppWindowSearchAlt);

var _IconArrowButtonDown = require('./IconArrowButtonDown2.js');

var _IconArrowButtonDown2 = _interopRequireDefault(_IconArrowButtonDown);

var _IconArrowButtonDown3 = require('./IconArrowButtonDown.js');

var _IconArrowButtonDown4 = _interopRequireDefault(_IconArrowButtonDown3);

var _IconArrowButtonLeft = require('./IconArrowButtonLeft2.js');

var _IconArrowButtonLeft2 = _interopRequireDefault(_IconArrowButtonLeft);

var _IconArrowButtonLeft3 = require('./IconArrowButtonLeft.js');

var _IconArrowButtonLeft4 = _interopRequireDefault(_IconArrowButtonLeft3);

var _IconArrowButtonRight = require('./IconArrowButtonRight2.js');

var _IconArrowButtonRight2 = _interopRequireDefault(_IconArrowButtonRight);

var _IconArrowButtonRight3 = require('./IconArrowButtonRight.js');

var _IconArrowButtonRight4 = _interopRequireDefault(_IconArrowButtonRight3);

var _IconArrowButtonUp = require('./IconArrowButtonUp2.js');

var _IconArrowButtonUp2 = _interopRequireDefault(_IconArrowButtonUp);

var _IconArrowButtonUp3 = require('./IconArrowButtonUp.js');

var _IconArrowButtonUp4 = _interopRequireDefault(_IconArrowButtonUp3);

var _IconArrowCircleDown = require('./IconArrowCircleDown.js');

var _IconArrowCircleDown2 = _interopRequireDefault(_IconArrowCircleDown);

var _IconArrowCircleLeft = require('./IconArrowCircleLeft.js');

var _IconArrowCircleLeft2 = _interopRequireDefault(_IconArrowCircleLeft);

var _IconArrowCircleRight = require('./IconArrowCircleRight.js');

var _IconArrowCircleRight2 = _interopRequireDefault(_IconArrowCircleRight);

var _IconArrowCircleUp = require('./IconArrowCircleUp.js');

var _IconArrowCircleUp2 = _interopRequireDefault(_IconArrowCircleUp);

var _IconApparelCategory = require('./IconApparelCategory.js');

var _IconApparelCategory2 = _interopRequireDefault(_IconApparelCategory);

var _IconArrowDownAlt = require('./IconArrowDownAlt.js');

var _IconArrowDownAlt2 = _interopRequireDefault(_IconArrowDownAlt);

var _IconArrowDown = require('./IconArrowDown.js');

var _IconArrowDown2 = _interopRequireDefault(_IconArrowDown);

var _IconArrowLeftAlt = require('./IconArrowLeftAlt.js');

var _IconArrowLeftAlt2 = _interopRequireDefault(_IconArrowLeftAlt);

var _IconArrowLeft = require('./IconArrowLeft.js');

var _IconArrowLeft2 = _interopRequireDefault(_IconArrowLeft);

var _IconArrowRightAlt = require('./IconArrowRightAlt.js');

var _IconArrowRightAlt2 = _interopRequireDefault(_IconArrowRightAlt);

var _IconArrowRight = require('./IconArrowRight.js');

var _IconArrowRight2 = _interopRequireDefault(_IconArrowRight);

var _IconArrowThickDown = require('./IconArrowThickDown.js');

var _IconArrowThickDown2 = _interopRequireDefault(_IconArrowThickDown);

var _IconArrowThickLeft = require('./IconArrowThickLeft.js');

var _IconArrowThickLeft2 = _interopRequireDefault(_IconArrowThickLeft);

var _IconArrowThickRight = require('./IconArrowThickRight.js');

var _IconArrowThickRight2 = _interopRequireDefault(_IconArrowThickRight);

var _IconArrowThickUp = require('./IconArrowThickUp.js');

var _IconArrowThickUp2 = _interopRequireDefault(_IconArrowThickUp);

var _IconArrowUpAlt = require('./IconArrowUpAlt.js');

var _IconArrowUpAlt2 = _interopRequireDefault(_IconArrowUpAlt);

var _IconArrowUp = require('./IconArrowUp.js');

var _IconArrowUp2 = _interopRequireDefault(_IconArrowUp);

var _IconArtboardShrink = require('./IconArtboardShrink.js');

var _IconArtboardShrink2 = _interopRequireDefault(_IconArtboardShrink);

var _IconAttachment = require('./IconAttachment.js');

var _IconAttachment2 = _interopRequireDefault(_IconAttachment);

var _IconBagsCategory = require('./IconBagsCategory.js');

var _IconBagsCategory2 = _interopRequireDefault(_IconBagsCategory);

var _IconBarcode = require('./IconBarcode.js');

var _IconBarcode2 = _interopRequireDefault(_IconBarcode);

var _IconBin = require('./IconBin.js');

var _IconBin2 = _interopRequireDefault(_IconBin);

var _IconBottomOfRow = require('./IconBottomOfRow.js');

var _IconBottomOfRow2 = _interopRequireDefault(_IconBottomOfRow);

var _IconBusinessContractHandshakeSign = require('./IconBusinessContractHandshakeSign.js');

var _IconBusinessContractHandshakeSign2 = _interopRequireDefault(_IconBusinessContractHandshakeSign);

var _IconBusinessDealCashExchange = require('./IconBusinessDealCashExchange.js');

var _IconBusinessDealCashExchange2 = _interopRequireDefault(_IconBusinessDealCashExchange);

var _IconButtonPause = require('./IconButtonPause.js');

var _IconButtonPause2 = _interopRequireDefault(_IconButtonPause);

var _IconButtonStop = require('./IconButtonStop.js');

var _IconButtonStop2 = _interopRequireDefault(_IconButtonStop);

var _IconCalendarHome = require('./IconCalendarHome.js');

var _IconCalendarHome2 = _interopRequireDefault(_IconCalendarHome);

var _IconCalendarPlane = require('./IconCalendarPlane.js');

var _IconCalendarPlane2 = _interopRequireDefault(_IconCalendarPlane);

var _IconCalendar = require('./IconCalendar.js');

var _IconCalendar2 = _interopRequireDefault(_IconCalendar);

var _IconCap = require('./IconCap2.js');

var _IconCap2 = _interopRequireDefault(_IconCap);

var _IconCashEye = require('./IconCashEye.js');

var _IconCashEye2 = _interopRequireDefault(_IconCashEye);

var _IconChargerAlt = require('./IconChargerAlt.js');

var _IconChargerAlt2 = _interopRequireDefault(_IconChargerAlt);

var _IconCheckBadge = require('./IconCheckBadge.js');

var _IconCheckBadge2 = _interopRequireDefault(_IconCheckBadge);

var _IconCheckCircleAlt = require('./IconCheckCircleAlt.js');

var _IconCheckCircleAlt2 = _interopRequireDefault(_IconCheckCircleAlt);

var _IconCheckSquare = require('./IconCheckSquare.js');

var _IconCheckSquare2 = _interopRequireDefault(_IconCheckSquare);

var _IconCheck = require('./IconCheck.js');

var _IconCheck2 = _interopRequireDefault(_IconCheck);

var _IconChecklist = require('./IconChecklist.js');

var _IconChecklist2 = _interopRequireDefault(_IconChecklist);

var _IconClose = require('./IconClose.js');

var _IconClose2 = _interopRequireDefault(_IconClose);

var _IconCloudUpload = require('./IconCloudUpload.js');

var _IconCloudUpload2 = _interopRequireDefault(_IconCloudUpload);

var _IconCogApproved = require('./IconCogApproved.js');

var _IconCogApproved2 = _interopRequireDefault(_IconCogApproved);

var _IconCogDouble = require('./IconCogDouble.js');

var _IconCogDouble2 = _interopRequireDefault(_IconCogDouble);

var _IconCog = require('./IconCog.js');

var _IconCog2 = _interopRequireDefault(_IconCog);

var _IconColorBucketAlt = require('./IconColorBucketAlt.js');

var _IconColorBucketAlt2 = _interopRequireDefault(_IconColorBucketAlt);

var _IconColorBucket = require('./IconColorBucket.js');

var _IconColorBucket2 = _interopRequireDefault(_IconColorBucket);

var _IconColorPaintingPalette = require('./IconColorPaintingPalette.js');

var _IconColorPaintingPalette2 = _interopRequireDefault(_IconColorPaintingPalette);

var _IconColorPicker = require('./IconColorPicker3.js');

var _IconColorPicker2 = _interopRequireDefault(_IconColorPicker);

var _IconCommonFileStack = require('./IconCommonFileStack.js');

var _IconCommonFileStack2 = _interopRequireDefault(_IconCommonFileStack);

var _IconCommonFileText = require('./IconCommonFileText.js');

var _IconCommonFileText2 = _interopRequireDefault(_IconCommonFileText);

var _IconCompare = require('./IconCompare.js');

var _IconCompare2 = _interopRequireDefault(_IconCompare);

var _IconCompassAlt = require('./IconCompassAlt.js');

var _IconCompassAlt2 = _interopRequireDefault(_IconCompassAlt);

var _IconConfigureTemplate = require('./IconConfigureTemplate.js');

var _IconConfigureTemplate2 = _interopRequireDefault(_IconConfigureTemplate);

var _IconControlsPlay = require('./IconControlsPlay.js');

var _IconControlsPlay2 = _interopRequireDefault(_IconControlsPlay);

var _IconConversationChatAlt = require('./IconConversationChatAlt.js');

var _IconConversationChatAlt2 = _interopRequireDefault(_IconConversationChatAlt);

var _IconCopyPaste = require('./IconCopyPaste.js');

var _IconCopyPaste2 = _interopRequireDefault(_IconCopyPaste);

var _IconCopy = require('./IconCopy.js');

var _IconCopy2 = _interopRequireDefault(_IconCopy);

var _IconCurrencyEuroDollarExchange = require('./IconCurrencyEuroDollarExchange.js');

var _IconCurrencyEuroDollarExchange2 = _interopRequireDefault(_IconCurrencyEuroDollarExchange);

var _IconDeliveryTruck = require('./IconDeliveryTruck2.js');

var _IconDeliveryTruck2 = _interopRequireDefault(_IconDeliveryTruck);

var _IconDeliveryTruckClock = require('./IconDeliveryTruckClock.js');

var _IconDeliveryTruckClock2 = _interopRequireDefault(_IconDeliveryTruckClock);

var _IconDesignToolPenStation = require('./IconDesignToolPenStation.js');

var _IconDesignToolPenStation2 = _interopRequireDefault(_IconDesignToolPenStation);

var _IconDesignWarpCylinder = require('./IconDesignWarpCylinder.js');

var _IconDesignWarpCylinder2 = _interopRequireDefault(_IconDesignWarpCylinder);

var _IconDesignWarpPerspective = require('./IconDesignWarpPerspective.js');

var _IconDesignWarpPerspective2 = _interopRequireDefault(_IconDesignWarpPerspective);

var _IconDesktopMonitorApprove = require('./IconDesktopMonitorApprove.js');

var _IconDesktopMonitorApprove2 = _interopRequireDefault(_IconDesktopMonitorApprove);

var _IconDirectionButtonArrows = require('./IconDirectionButtonArrows.js');

var _IconDirectionButtonArrows2 = _interopRequireDefault(_IconDirectionButtonArrows);

var _IconDiscount = require('./IconDiscount.js');

var _IconDiscount2 = _interopRequireDefault(_IconDiscount);

var _IconDownloadBottom = require('./IconDownloadBottom.js');

var _IconDownloadBottom2 = _interopRequireDefault(_IconDownloadBottom);

var _IconDragDrop = require('./IconDragDrop.js');

var _IconDragDrop2 = _interopRequireDefault(_IconDragDrop);

var _IconDataTransferHorizontal = require('./IconDataTransferHorizontal.js');

var _IconDataTransferHorizontal2 = _interopRequireDefault(_IconDataTransferHorizontal);

var _IconDeliveryParachute = require('./IconDeliveryParachute.js');

var _IconDeliveryParachute2 = _interopRequireDefault(_IconDeliveryParachute);

var _IconDeliveryTruckBoxes = require('./IconDeliveryTruckBoxes.js');

var _IconDeliveryTruckBoxes2 = _interopRequireDefault(_IconDeliveryTruckBoxes);

var _IconDragHorizontial = require('./IconDragHorizontial.js');

var _IconDragHorizontial2 = _interopRequireDefault(_IconDragHorizontial);

var _IconDragVertical = require('./IconDragVertical.js');

var _IconDragVertical2 = _interopRequireDefault(_IconDragVertical);

var _IconDrawerFile = require('./IconDrawerFile.js');

var _IconDrawerFile2 = _interopRequireDefault(_IconDrawerFile);

var _IconDrawerOpen = require('./IconDrawerOpen.js');

var _IconDrawerOpen2 = _interopRequireDefault(_IconDrawerOpen);

var _IconDrop = require('./IconDrop.js');

var _IconDrop2 = _interopRequireDefault(_IconDrop);

var _IconEarth = require('./IconEarth3.js');

var _IconEarth2 = _interopRequireDefault(_IconEarth);

var _IconEarthAlt = require('./IconEarthAlt.js');

var _IconEarthAlt2 = _interopRequireDefault(_IconEarthAlt);

var _IconEmailActionCash = require('./IconEmailActionCash.js');

var _IconEmailActionCash2 = _interopRequireDefault(_IconEmailActionCash);

var _IconEmailActionUnread = require('./IconEmailActionUnread.js');

var _IconEmailActionUnread2 = _interopRequireDefault(_IconEmailActionUnread);

var _IconEmailSend = require('./IconEmailSend.js');

var _IconEmailSend2 = _interopRequireDefault(_IconEmailSend);

var _IconExpand = require('./IconExpand5.js');

var _IconExpand2 = _interopRequireDefault(_IconExpand);

var _IconExpandDiagonal = require('./IconExpandDiagonal2.js');

var _IconExpandDiagonal2 = _interopRequireDefault(_IconExpandDiagonal);

var _IconFactory = require('./IconFactory.js');

var _IconFactory2 = _interopRequireDefault(_IconFactory);

var _IconFileCode = require('./IconFileCode.js');

var _IconFileCode2 = _interopRequireDefault(_IconFileCode);

var _IconFilterAlt = require('./IconFilterAlt.js');

var _IconFilterAlt2 = _interopRequireDefault(_IconFilterAlt);

var _IconFinalizeContract = require('./IconFinalizeContract.js');

var _IconFinalizeContract2 = _interopRequireDefault(_IconFinalizeContract);

var _IconFinalizePriceList = require('./IconFinalizePriceList.js');

var _IconFinalizePriceList2 = _interopRequireDefault(_IconFinalizePriceList);

var _IconFloppyDiskAlt = require('./IconFloppyDiskAlt.js');

var _IconFloppyDiskAlt2 = _interopRequireDefault(_IconFloppyDiskAlt);

var _IconFocusLandscape = require('./IconFocusLandscape.js');

var _IconFocusLandscape2 = _interopRequireDefault(_IconFocusLandscape);

var _IconFolderImage = require('./IconFolderImage.js');

var _IconFolderImage2 = _interopRequireDefault(_IconFolderImage);

var _IconFolderCode = require('./IconFolderCode.js');

var _IconFolderCode2 = _interopRequireDefault(_IconFolderCode);

var _IconFulfillerCreate = require('./IconFulfillerCreate.js');

var _IconFulfillerCreate2 = _interopRequireDefault(_IconFulfillerCreate);

var _IconGaugeDashboard = require('./IconGaugeDashboard.js');

var _IconGaugeDashboard2 = _interopRequireDefault(_IconGaugeDashboard);

var _IconGiftsCategory = require('./IconGiftsCategory.js');

var _IconGiftsCategory2 = _interopRequireDefault(_IconGiftsCategory);

var _IconGridGuides = require('./IconGridGuides.js');

var _IconGridGuides2 = _interopRequireDefault(_IconGridGuides);

var _IconHierarchyFlow = require('./IconHierarchyFlow.js');

var _IconHierarchyFlow2 = _interopRequireDefault(_IconHierarchyFlow);

var _IconHierarchyNode = require('./IconHierarchyNode.js');

var _IconHierarchyNode2 = _interopRequireDefault(_IconHierarchyNode);

var _IconHouse = require('./IconHouse.js');

var _IconHouse2 = _interopRequireDefault(_IconHouse);

var _IconHyperlink = require('./IconHyperlink.js');

var _IconHyperlink2 = _interopRequireDefault(_IconHyperlink);

var _IconIdCard = require('./IconIdCard.js');

var _IconIdCard2 = _interopRequireDefault(_IconIdCard);

var _IconImageFileAdd = require('./IconImageFileAdd.js');

var _IconImageFileAdd2 = _interopRequireDefault(_IconImageFileAdd);

var _IconImageFileEdit = require('./IconImageFileEdit.js');

var _IconImageFileEdit2 = _interopRequireDefault(_IconImageFileEdit);

var _IconImageFileSettings = require('./IconImageFileSettings.js');

var _IconImageFileSettings2 = _interopRequireDefault(_IconImageFileSettings);

var _IconInformationCircle = require('./IconInformationCircle.js');

var _IconInformationCircle2 = _interopRequireDefault(_IconInformationCircle);

var _IconIrisScanLock = require('./IconIrisScanLock.js');

var _IconIrisScanLock2 = _interopRequireDefault(_IconIrisScanLock);

var _IconLargeFormatCategory = require('./IconLargeFormatCategory.js');

var _IconLargeFormatCategory2 = _interopRequireDefault(_IconLargeFormatCategory);

var _IconLayersBack = require('./IconLayersBack.js');

var _IconLayersBack2 = _interopRequireDefault(_IconLayersBack);

var _IconLayersFront = require('./IconLayersFront.js');

var _IconLayersFront2 = _interopRequireDefault(_IconLayersFront);

var _IconLayoutDashboard = require('./IconLayoutDashboard.js');

var _IconLayoutDashboard2 = _interopRequireDefault(_IconLayoutDashboard);

var _IconLayers = require('./IconLayers.js');

var _IconLayers2 = _interopRequireDefault(_IconLayers);

var _IconLayoutModule = require('./IconLayoutModule.js');

var _IconLayoutModule2 = _interopRequireDefault(_IconLayoutModule);

var _IconLeftOfColumn = require('./IconLeftOfColumn.js');

var _IconLeftOfColumn2 = _interopRequireDefault(_IconLeftOfColumn);

var _IconListBullets = require('./IconListBullets.js');

var _IconListBullets2 = _interopRequireDefault(_IconListBullets);

var _IconLoadingCircleAlt = require('./IconLoadingCircleAlt.js');

var _IconLoadingCircleAlt2 = _interopRequireDefault(_IconLoadingCircleAlt);

var _IconLoadingHalf = require('./IconLoadingHalf.js');

var _IconLoadingHalf2 = _interopRequireDefault(_IconLoadingHalf);

var _IconLockAlt = require('./IconLockAlt.js');

var _IconLockAlt2 = _interopRequireDefault(_IconLockAlt);

var _IconLockUnlock = require('./IconLockUnlock.js');

var _IconLockUnlock2 = _interopRequireDefault(_IconLockUnlock);

var _IconMessagesBubbleInformation = require('./IconMessagesBubbleInformation.js');

var _IconMessagesBubbleInformation2 = _interopRequireDefault(_IconMessagesBubbleInformation);

var _IconMessagesBubbleQuestion = require('./IconMessagesBubbleQuestion.js');

var _IconMessagesBubbleQuestion2 = _interopRequireDefault(_IconMessagesBubbleQuestion);

var _IconMessagesBubble = require('./IconMessagesBubble.js');

var _IconMessagesBubble2 = _interopRequireDefault(_IconMessagesBubble);

var _IconMonitorShoppingCart = require('./IconMonitorShoppingCart.js');

var _IconMonitorShoppingCart2 = _interopRequireDefault(_IconMonitorShoppingCart);

var _IconMultipleActionsRemove = require('./IconMultipleActionsRemove.js');

var _IconMultipleActionsRemove2 = _interopRequireDefault(_IconMultipleActionsRemove);

var _IconMonitorAlt = require('./IconMonitorAlt.js');

var _IconMonitorAlt2 = _interopRequireDefault(_IconMonitorAlt);

var _IconMessagesPeopleUserDollar = require('./IconMessagesPeopleUserDollar.js');

var _IconMessagesPeopleUserDollar2 = _interopRequireDefault(_IconMessagesPeopleUserDollar);

var _IconNavigationMenuVertical = require('./IconNavigationMenuVertical.js');

var _IconNavigationMenuVertical2 = _interopRequireDefault(_IconNavigationMenuVertical);

var _IconNavigationMenu = require('./IconNavigationMenu.js');

var _IconNavigationMenu2 = _interopRequireDefault(_IconNavigationMenu);

var _IconMultipleUsers = require('./IconMultipleUsers.js');

var _IconMultipleUsers2 = _interopRequireDefault(_IconMultipleUsers);

var _IconNavigationNext = require('./IconNavigationNext.js');

var _IconNavigationNext2 = _interopRequireDefault(_IconNavigationNext);

var _IconNewspaper = require('./IconNewspaper.js');

var _IconNewspaper2 = _interopRequireDefault(_IconNewspaper);

var _IconNumeric = require('./IconNumeric.js');

var _IconNumeric2 = _interopRequireDefault(_IconNumeric);

var _IconNetworkPin = require('./IconNetworkPin.js');

var _IconNetworkPin2 = _interopRequireDefault(_IconNetworkPin);

var _IconOfficeFilePdf = require('./IconOfficeFilePdf.js');

var _IconOfficeFilePdf2 = _interopRequireDefault(_IconOfficeFilePdf);

var _IconOfficeFileXls = require('./IconOfficeFileXls.js');

var _IconOfficeFileXls2 = _interopRequireDefault(_IconOfficeFileXls);

var _IconPackageCategory = require('./IconPackageCategory.js');

var _IconPackageCategory2 = _interopRequireDefault(_IconPackageCategory);

var _IconParagraphCenterAlign = require('./IconParagraphCenterAlign.js');

var _IconParagraphCenterAlign2 = _interopRequireDefault(_IconParagraphCenterAlign);

var _IconParagraphLeftAlign = require('./IconParagraphLeftAlign.js');

var _IconParagraphLeftAlign2 = _interopRequireDefault(_IconParagraphLeftAlign);

var _IconParagraphRightAlign = require('./IconParagraphRightAlign.js');

var _IconParagraphRightAlign2 = _interopRequireDefault(_IconParagraphRightAlign);

var _IconPencilAlt = require('./IconPencilAlt.js');

var _IconPencilAlt2 = _interopRequireDefault(_IconPencilAlt);

var _IconPencilCircle = require('./IconPencilCircle.js');

var _IconPencilCircle2 = _interopRequireDefault(_IconPencilCircle);

var _IconPerformanceIncreaseAlt = require('./IconPerformanceIncreaseAlt.js');

var _IconPerformanceIncreaseAlt2 = _interopRequireDefault(_IconPerformanceIncreaseAlt);

var _IconPictureFlowerAlt = require('./IconPictureFlowerAlt.js');

var _IconPictureFlowerAlt2 = _interopRequireDefault(_IconPictureFlowerAlt);

var _IconPicturePolaroidAlbumAlt = require('./IconPicturePolaroidAlbumAlt.js');

var _IconPicturePolaroidAlbumAlt2 = _interopRequireDefault(_IconPicturePolaroidAlbumAlt);

var _IconPicturePolaroidLandscape = require('./IconPicturePolaroidLandscape.js');

var _IconPicturePolaroidLandscape2 = _interopRequireDefault(_IconPicturePolaroidLandscape);

var _IconPictureSun = require('./IconPictureSun.js');

var _IconPictureSun2 = _interopRequireDefault(_IconPictureSun);

var _IconPin = require('./IconPin.js');

var _IconPin2 = _interopRequireDefault(_IconPin);

var _IconPinLocationAlt = require('./IconPinLocationAlt.js');

var _IconPinLocationAlt2 = _interopRequireDefault(_IconPinLocationAlt);

var _IconPrintPicture = require('./IconPrintPicture.js');

var _IconPrintPicture2 = _interopRequireDefault(_IconPrintPicture);

var _IconProductPricingTerms = require('./IconProductPricingTerms.js');

var _IconProductPricingTerms2 = _interopRequireDefault(_IconProductPricingTerms);

var _IconProductsBriefcase = require('./IconProductsBriefcase.js');

var _IconProductsBriefcase2 = _interopRequireDefault(_IconProductsBriefcase);

var _IconPromoProductsCategory = require('./IconPromoProductsCategory.js');

var _IconPromoProductsCategory2 = _interopRequireDefault(_IconPromoProductsCategory);

var _IconQuestionCircle = require('./IconQuestionCircle.js');

var _IconQuestionCircle2 = _interopRequireDefault(_IconQuestionCircle);

var _IconQuoterRecommendations = require('./IconQuoterRecommendations.js');

var _IconQuoterRecommendations2 = _interopRequireDefault(_IconQuoterRecommendations);

var _IconQuoter = require('./IconQuoter.js');

var _IconQuoter2 = _interopRequireDefault(_IconQuoter);

var _IconRatingStar = require('./IconRatingStar.js');

var _IconRatingStar2 = _interopRequireDefault(_IconRatingStar);

var _IconRatingStarAlt = require('./IconRatingStarAlt.js');

var _IconRatingStarAlt2 = _interopRequireDefault(_IconRatingStarAlt);

var _IconReceiptDollar = require('./IconReceiptDollar.js');

var _IconReceiptDollar2 = _interopRequireDefault(_IconReceiptDollar);

var _IconReceiptRegisterPrint = require('./IconReceiptRegisterPrint.js');

var _IconReceiptRegisterPrint2 = _interopRequireDefault(_IconReceiptRegisterPrint);

var _IconRedo = require('./IconRedo.js');

var _IconRedo2 = _interopRequireDefault(_IconRedo);

var _IconRemoveCircle = require('./IconRemoveCircle.js');

var _IconRemoveCircle2 = _interopRequireDefault(_IconRemoveCircle);

var _IconRemoveColumn = require('./IconRemoveColumn.js');

var _IconRemoveColumn2 = _interopRequireDefault(_IconRemoveColumn);

var _IconRemoveRow = require('./IconRemoveRow.js');

var _IconRemoveRow2 = _interopRequireDefault(_IconRemoveRow);

var _IconRemove = require('./IconRemove.js');

var _IconRemove2 = _interopRequireDefault(_IconRemove);

var _IconRightOfColumn = require('./IconRightOfColumn.js');

var _IconRightOfColumn2 = _interopRequireDefault(_IconRightOfColumn);

var _IconRoadSignBanned = require('./IconRoadSignBanned.js');

var _IconRoadSignBanned2 = _interopRequireDefault(_IconRoadSignBanned);

var _IconRuler = require('./IconRuler.js');

var _IconRuler2 = _interopRequireDefault(_IconRuler);

var _IconSearchStar = require('./IconSearchStar.js');

var _IconSearchStar2 = _interopRequireDefault(_IconSearchStar);

var _IconSearch = require('./IconSearch.js');

var _IconSearch2 = _interopRequireDefault(_IconSearch);

var _IconSettingsSlider = require('./IconSettingsSlider.js');

var _IconSettingsSlider2 = _interopRequireDefault(_IconSettingsSlider);

var _IconSettingsVertical = require('./IconSettingsVertical.js');

var _IconSettingsVertical2 = _interopRequireDefault(_IconSettingsVertical);

var _IconSettingsToggleHorizontal = require('./IconSettingsToggleHorizontal.js');

var _IconSettingsToggleHorizontal2 = _interopRequireDefault(_IconSettingsToggleHorizontal);

var _IconShareAlt = require('./IconShareAlt.js');

var _IconShareAlt2 = _interopRequireDefault(_IconShareAlt);

var _IconShipmentBox = require('./IconShipmentBox.js');

var _IconShipmentBox2 = _interopRequireDefault(_IconShipmentBox);

var _IconShipmentCash = require('./IconShipmentCash.js');

var _IconShipmentCash2 = _interopRequireDefault(_IconShipmentCash);

var _IconShipmentCheck = require('./IconShipmentCheck.js');

var _IconShipmentCheck2 = _interopRequireDefault(_IconShipmentCheck);

var _IconShipmentGive = require('./IconShipmentGive.js');

var _IconShipmentGive2 = _interopRequireDefault(_IconShipmentGive);

var _IconShipmentPackages = require('./IconShipmentPackages.js');

var _IconShipmentPackages2 = _interopRequireDefault(_IconShipmentPackages);

var _IconShipmentPlane = require('./IconShipmentPlane.js');

var _IconShipmentPlane2 = _interopRequireDefault(_IconShipmentPlane);

var _IconShipmentTruck = require('./IconShipmentTruck.js');

var _IconShipmentTruck2 = _interopRequireDefault(_IconShipmentTruck);

var _IconShirtPlain = require('./IconShirtPlain.js');

var _IconShirtPlain2 = _interopRequireDefault(_IconShirtPlain);

var _IconShipmentUploadAlt = require('./IconShipmentUploadAlt.js');

var _IconShipmentUploadAlt2 = _interopRequireDefault(_IconShipmentUploadAlt);

var _IconShop = require('./IconShop.js');

var _IconShop2 = _interopRequireDefault(_IconShop);

var _IconShoppingBasketAdd = require('./IconShoppingBasketAdd.js');

var _IconShoppingBasketAdd2 = _interopRequireDefault(_IconShoppingBasketAdd);

var _IconShoppingBasketAlt = require('./IconShoppingBasketAlt.js');

var _IconShoppingBasketAlt2 = _interopRequireDefault(_IconShoppingBasketAlt);

var _IconShoppingCartAlt = require('./IconShoppingCartAlt.js');

var _IconShoppingCartAlt2 = _interopRequireDefault(_IconShoppingCartAlt);

var _IconShoppingCartFull = require('./IconShoppingCartFull.js');

var _IconShoppingCartFull2 = _interopRequireDefault(_IconShoppingCartFull);

var _IconStartContract = require('./IconStartContract.js');

var _IconStartContract2 = _interopRequireDefault(_IconStartContract);

var _IconStartPriceList = require('./IconStartPriceList.js');

var _IconStartPriceList2 = _interopRequireDefault(_IconStartPriceList);

var _IconSmallFormatCategory = require('./IconSmallFormatCategory.js');

var _IconSmallFormatCategory2 = _interopRequireDefault(_IconSmallFormatCategory);

var _IconSynchronizeArrowClock = require('./IconSynchronizeArrowClock.js');

var _IconSynchronizeArrowClock2 = _interopRequireDefault(_IconSynchronizeArrowClock);

var _IconSynchronizeArrowsAlt = require('./IconSynchronizeArrowsAlt.js');

var _IconSynchronizeArrowsAlt2 = _interopRequireDefault(_IconSynchronizeArrowsAlt);

var _IconTagDollarAlt = require('./IconTagDollarAlt.js');

var _IconTagDollarAlt2 = _interopRequireDefault(_IconTagDollarAlt);

var _IconTapCheck = require('./IconTapCheck.js');

var _IconTapCheck2 = _interopRequireDefault(_IconTapCheck);

var _IconTaskListWarning = require('./IconTaskListWarning.js');

var _IconTaskListWarning2 = _interopRequireDefault(_IconTaskListWarning);

var _IconTextItalic = require('./IconTextItalic.js');

var _IconTextItalic2 = _interopRequireDefault(_IconTextItalic);

var _IconTextStrikeThrough = require('./IconTextStrikeThrough.js');

var _IconTextStrikeThrough2 = _interopRequireDefault(_IconTextStrikeThrough);

var _IconTextUnderline = require('./IconTextUnderline.js');

var _IconTextUnderline2 = _interopRequireDefault(_IconTextUnderline);

var _IconTextBold = require('./IconTextBold.js');

var _IconTextBold2 = _interopRequireDefault(_IconTextBold);

var _IconTimeClockCircle = require('./IconTimeClockCircle.js');

var _IconTimeClockCircle2 = _interopRequireDefault(_IconTimeClockCircle);

var _IconTimeStopwatch = require('./IconTimeStopwatch.js');

var _IconTimeStopwatch2 = _interopRequireDefault(_IconTimeStopwatch);

var _IconTopOfRow = require('./IconTopOfRow.js');

var _IconTopOfRow2 = _interopRequireDefault(_IconTopOfRow);

var _IconTruckCargo = require('./IconTruckCargo.js');

var _IconTruckCargo2 = _interopRequireDefault(_IconTruckCargo);

var _IconTruckConfigure = require('./IconTruckConfigure.js');

var _IconTruckConfigure2 = _interopRequireDefault(_IconTruckConfigure);

var _IconUndo = require('./IconUndo.js');

var _IconUndo2 = _interopRequireDefault(_IconUndo);

var _IconUploadBottom = require('./IconUploadBottom.js');

var _IconUploadBottom2 = _interopRequireDefault(_IconUploadBottom);

var _IconUserActionsRemove = require('./IconUserActionsRemove.js');

var _IconUserActionsRemove2 = _interopRequireDefault(_IconUserActionsRemove);

var _IconUserAlt = require('./IconUserAlt.js');

var _IconUserAlt2 = _interopRequireDefault(_IconUserAlt);

var _IconUserLock = require('./IconUserLock.js');

var _IconUserLock2 = _interopRequireDefault(_IconUserLock);

var _IconUserPhoneBook = require('./IconUserPhoneBook.js');

var _IconUserPhoneBook2 = _interopRequireDefault(_IconUserPhoneBook);

var _IconUserSetting = require('./IconUserSetting.js');

var _IconUserSetting2 = _interopRequireDefault(_IconUserSetting);

var _IconVectorsAnchorSquareAlt = require('./IconVectorsAnchorSquareAlt.js');

var _IconVectorsAnchorSquareAlt2 = _interopRequireDefault(_IconVectorsAnchorSquareAlt);

var _IconViewColumn = require('./IconViewColumn.js');

var _IconViewColumn2 = _interopRequireDefault(_IconViewColumn);

var _IconVideoPlayerMovieAlt = require('./IconVideoPlayerMovieAlt.js');

var _IconVideoPlayerMovieAlt2 = _interopRequireDefault(_IconVideoPlayerMovieAlt);

var _IconViewOff = require('./IconViewOff.js');

var _IconViewOff2 = _interopRequireDefault(_IconViewOff);

var _IconView = require('./IconView.js');

var _IconView2 = _interopRequireDefault(_IconView);

var _IconWarehousePackages = require('./IconWarehousePackages.js');

var _IconWarehousePackages2 = _interopRequireDefault(_IconWarehousePackages);

var _IconZoomIn = require('./IconZoomIn.js');

var _IconZoomIn2 = _interopRequireDefault(_IconZoomIn);

var _IconWarehouseCartPackage = require('./IconWarehouseCartPackage.js');

var _IconWarehouseCartPackage2 = _interopRequireDefault(_IconWarehouseCartPackage);

var _IconWarehouseCartPackages = require('./IconWarehouseCartPackages2.js');

var _IconWarehouseCartPackages2 = _interopRequireDefault(_IconWarehouseCartPackages);

var _IconZoomOut = require('./IconZoomOut.js');

var _IconZoomOut2 = _interopRequireDefault(_IconZoomOut);

var _IconUser = require('./IconUser.js');

var _IconUser2 = _interopRequireDefault(_IconUser);

var _IconBookOpen = require('./IconBookOpen.js');

var _IconBookOpen2 = _interopRequireDefault(_IconBookOpen);

var _IconBookOpenBookmark = require('./IconBookOpenBookmark.js');

var _IconBookOpenBookmark2 = _interopRequireDefault(_IconBookOpenBookmark);

var _IconBooksCategory = require('./IconBooksCategory.js');

var _IconBooksCategory2 = _interopRequireDefault(_IconBooksCategory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.IconAccountingCalculatorAlt = _IconAccountingCalculatorAlt2.default;
exports.IconAccountingCalculator = _IconAccountingCalculator2.default;
exports.IconAccountingCoinsBill = _IconAccountingCoinsBill2.default;
exports.IconAddCircle = _IconAddCircle2.default;
exports.IconAccountingDocument = _IconAccountingDocument2.default;
exports.IconAddProduct = _IconAddProduct2.default;
exports.IconAddSquare = _IconAddSquare2.default;
exports.IconAdd = _IconAdd2.default;
exports.IconAlarmBellOff = _IconAlarmBellOff2.default;
exports.IconAlertTriangle = _IconAlertTriangle2.default;
exports.IconAlarmBell = _IconAlarmBell2.default;
exports.IconAnalyticsGraph = _IconAnalyticsGraph2.default;
exports.IconAnalyticsPieAlt = _IconAnalyticsPieAlt2.default;
exports.IconAngleBrackets = _IconAngleBrackets2.default;
exports.IconAppWindowLayout = _IconAppWindowLayout2.default;
exports.IconAppWindowNext = _IconAppWindowNext2.default;
exports.IconAppWindowSearchAlt = _IconAppWindowSearchAlt2.default;
exports.IconArrowButtonDown2 = _IconArrowButtonDown2.default;
exports.IconArrowButtonDown = _IconArrowButtonDown4.default;
exports.IconArrowButtonLeft2 = _IconArrowButtonLeft2.default;
exports.IconArrowButtonLeft = _IconArrowButtonLeft4.default;
exports.IconArrowButtonRight2 = _IconArrowButtonRight2.default;
exports.IconArrowButtonRight = _IconArrowButtonRight4.default;
exports.IconArrowButtonUp2 = _IconArrowButtonUp2.default;
exports.IconArrowButtonUp = _IconArrowButtonUp4.default;
exports.IconArrowCircleDown = _IconArrowCircleDown2.default;
exports.IconArrowCircleLeft = _IconArrowCircleLeft2.default;
exports.IconArrowCircleRight = _IconArrowCircleRight2.default;
exports.IconArrowCircleUp = _IconArrowCircleUp2.default;
exports.IconApparelCategory = _IconApparelCategory2.default;
exports.IconArrowDownAlt = _IconArrowDownAlt2.default;
exports.IconArrowDown = _IconArrowDown2.default;
exports.IconArrowLeftAlt = _IconArrowLeftAlt2.default;
exports.IconArrowLeft = _IconArrowLeft2.default;
exports.IconArrowRightAlt = _IconArrowRightAlt2.default;
exports.IconArrowRight = _IconArrowRight2.default;
exports.IconArrowThickDown = _IconArrowThickDown2.default;
exports.IconArrowThickLeft = _IconArrowThickLeft2.default;
exports.IconArrowThickRight = _IconArrowThickRight2.default;
exports.IconArrowThickUp = _IconArrowThickUp2.default;
exports.IconArrowUpAlt = _IconArrowUpAlt2.default;
exports.IconArrowUp = _IconArrowUp2.default;
exports.IconArtboardShrink = _IconArtboardShrink2.default;
exports.IconAttachment = _IconAttachment2.default;
exports.IconBagsCategory = _IconBagsCategory2.default;
exports.IconBarcode = _IconBarcode2.default;
exports.IconBin = _IconBin2.default;
exports.IconBottomOfRow = _IconBottomOfRow2.default;
exports.IconBusinessContractHandshakeSign = _IconBusinessContractHandshakeSign2.default;
exports.IconBusinessDealCashExchange = _IconBusinessDealCashExchange2.default;
exports.IconButtonPause = _IconButtonPause2.default;
exports.IconButtonStop = _IconButtonStop2.default;
exports.IconCalendarHome = _IconCalendarHome2.default;
exports.IconCalendarPlane = _IconCalendarPlane2.default;
exports.IconCalendar = _IconCalendar2.default;
exports.IconCap2 = _IconCap2.default;
exports.IconCashEye = _IconCashEye2.default;
exports.IconChargerAlt = _IconChargerAlt2.default;
exports.IconCheckBadge = _IconCheckBadge2.default;
exports.IconCheckCircleAlt = _IconCheckCircleAlt2.default;
exports.IconCheckSquare = _IconCheckSquare2.default;
exports.IconCheck = _IconCheck2.default;
exports.IconChecklist = _IconChecklist2.default;
exports.IconClose = _IconClose2.default;
exports.IconCloudUpload = _IconCloudUpload2.default;
exports.IconCogApproved = _IconCogApproved2.default;
exports.IconCogDouble = _IconCogDouble2.default;
exports.IconCog = _IconCog2.default;
exports.IconColorBucketAlt = _IconColorBucketAlt2.default;
exports.IconColorBucket = _IconColorBucket2.default;
exports.IconColorPaintingPalette = _IconColorPaintingPalette2.default;
exports.IconColorPicker3 = _IconColorPicker2.default;
exports.IconCommonFileStack = _IconCommonFileStack2.default;
exports.IconCommonFileText = _IconCommonFileText2.default;
exports.IconCompare = _IconCompare2.default;
exports.IconCompassAlt = _IconCompassAlt2.default;
exports.IconConfigureTemplate = _IconConfigureTemplate2.default;
exports.IconControlsPlay = _IconControlsPlay2.default;
exports.IconConversationChatAlt = _IconConversationChatAlt2.default;
exports.IconCopyPaste = _IconCopyPaste2.default;
exports.IconCopy = _IconCopy2.default;
exports.IconCurrencyEuroDollarExchange = _IconCurrencyEuroDollarExchange2.default;
exports.IconDeliveryTruck2 = _IconDeliveryTruck2.default;
exports.IconDeliveryTruckClock = _IconDeliveryTruckClock2.default;
exports.IconDesignToolPenStation = _IconDesignToolPenStation2.default;
exports.IconDesignWarpCylinder = _IconDesignWarpCylinder2.default;
exports.IconDesignWarpPerspective = _IconDesignWarpPerspective2.default;
exports.IconDesktopMonitorApprove = _IconDesktopMonitorApprove2.default;
exports.IconDirectionButtonArrows = _IconDirectionButtonArrows2.default;
exports.IconDiscount = _IconDiscount2.default;
exports.IconDownloadBottom = _IconDownloadBottom2.default;
exports.IconDragDrop = _IconDragDrop2.default;
exports.IconDataTransferHorizontal = _IconDataTransferHorizontal2.default;
exports.IconDeliveryParachute = _IconDeliveryParachute2.default;
exports.IconDeliveryTruckBoxes = _IconDeliveryTruckBoxes2.default;
exports.IconDragHorizontial = _IconDragHorizontial2.default;
exports.IconDragVertical = _IconDragVertical2.default;
exports.IconDrawerFile = _IconDrawerFile2.default;
exports.IconDrawerOpen = _IconDrawerOpen2.default;
exports.IconDrop = _IconDrop2.default;
exports.IconEarth3 = _IconEarth2.default;
exports.IconEarthAlt = _IconEarthAlt2.default;
exports.IconEmailActionCash = _IconEmailActionCash2.default;
exports.IconEmailActionUnread = _IconEmailActionUnread2.default;
exports.IconEmailSend = _IconEmailSend2.default;
exports.IconExpand5 = _IconExpand2.default;
exports.IconExpandDiagonal2 = _IconExpandDiagonal2.default;
exports.IconFactory = _IconFactory2.default;
exports.IconFileCode = _IconFileCode2.default;
exports.IconFilterAlt = _IconFilterAlt2.default;
exports.IconFinalizeContract = _IconFinalizeContract2.default;
exports.IconFinalizePriceList = _IconFinalizePriceList2.default;
exports.IconFloppyDiskAlt = _IconFloppyDiskAlt2.default;
exports.IconFocusLandscape = _IconFocusLandscape2.default;
exports.IconFolderImage = _IconFolderImage2.default;
exports.IconFolderCode = _IconFolderCode2.default;
exports.IconFulfillerCreate = _IconFulfillerCreate2.default;
exports.IconGaugeDashboard = _IconGaugeDashboard2.default;
exports.IconGiftsCategory = _IconGiftsCategory2.default;
exports.IconGridGuides = _IconGridGuides2.default;
exports.IconHierarchyFlow = _IconHierarchyFlow2.default;
exports.IconHierarchyNode = _IconHierarchyNode2.default;
exports.IconHouse = _IconHouse2.default;
exports.IconHyperlink = _IconHyperlink2.default;
exports.IconIdCard = _IconIdCard2.default;
exports.IconImageFileAdd = _IconImageFileAdd2.default;
exports.IconImageFileEdit = _IconImageFileEdit2.default;
exports.IconImageFileSettings = _IconImageFileSettings2.default;
exports.IconInformationCircle = _IconInformationCircle2.default;
exports.IconIrisScanLock = _IconIrisScanLock2.default;
exports.IconLargeFormatCategory = _IconLargeFormatCategory2.default;
exports.IconLayersBack = _IconLayersBack2.default;
exports.IconLayersFront = _IconLayersFront2.default;
exports.IconLayoutDashboard = _IconLayoutDashboard2.default;
exports.IconLayers = _IconLayers2.default;
exports.IconLayoutModule = _IconLayoutModule2.default;
exports.IconLeftOfColumn = _IconLeftOfColumn2.default;
exports.IconListBullets = _IconListBullets2.default;
exports.IconLoadingCircleAlt = _IconLoadingCircleAlt2.default;
exports.IconLoadingHalf = _IconLoadingHalf2.default;
exports.IconLockAlt = _IconLockAlt2.default;
exports.IconLockUnlock = _IconLockUnlock2.default;
exports.IconMessagesBubbleInformation = _IconMessagesBubbleInformation2.default;
exports.IconMessagesBubbleQuestion = _IconMessagesBubbleQuestion2.default;
exports.IconMessagesBubble = _IconMessagesBubble2.default;
exports.IconMonitorShoppingCart = _IconMonitorShoppingCart2.default;
exports.IconMultipleActionsRemove = _IconMultipleActionsRemove2.default;
exports.IconMonitorAlt = _IconMonitorAlt2.default;
exports.IconMessagesPeopleUserDollar = _IconMessagesPeopleUserDollar2.default;
exports.IconNavigationMenuVertical = _IconNavigationMenuVertical2.default;
exports.IconNavigationMenu = _IconNavigationMenu2.default;
exports.IconMultipleUsers = _IconMultipleUsers2.default;
exports.IconNavigationNext = _IconNavigationNext2.default;
exports.IconNewspaper = _IconNewspaper2.default;
exports.IconNumeric = _IconNumeric2.default;
exports.IconNetworkPin = _IconNetworkPin2.default;
exports.IconOfficeFilePdf = _IconOfficeFilePdf2.default;
exports.IconOfficeFileXls = _IconOfficeFileXls2.default;
exports.IconPackageCategory = _IconPackageCategory2.default;
exports.IconParagraphCenterAlign = _IconParagraphCenterAlign2.default;
exports.IconParagraphLeftAlign = _IconParagraphLeftAlign2.default;
exports.IconParagraphRightAlign = _IconParagraphRightAlign2.default;
exports.IconPencilAlt = _IconPencilAlt2.default;
exports.IconPencilCircle = _IconPencilCircle2.default;
exports.IconPerformanceIncreaseAlt = _IconPerformanceIncreaseAlt2.default;
exports.IconPictureFlowerAlt = _IconPictureFlowerAlt2.default;
exports.IconPicturePolaroidAlbumAlt = _IconPicturePolaroidAlbumAlt2.default;
exports.IconPicturePolaroidLandscape = _IconPicturePolaroidLandscape2.default;
exports.IconPictureSun = _IconPictureSun2.default;
exports.IconPin = _IconPin2.default;
exports.IconPinLocationAlt = _IconPinLocationAlt2.default;
exports.IconPrintPicture = _IconPrintPicture2.default;
exports.IconProductPricingTerms = _IconProductPricingTerms2.default;
exports.IconProductsBriefcase = _IconProductsBriefcase2.default;
exports.IconPromoProductsCategory = _IconPromoProductsCategory2.default;
exports.IconQuestionCircle = _IconQuestionCircle2.default;
exports.IconQuoterRecommendations = _IconQuoterRecommendations2.default;
exports.IconQuoter = _IconQuoter2.default;
exports.IconRatingStar = _IconRatingStar2.default;
exports.IconRatingStarAlt = _IconRatingStarAlt2.default;
exports.IconReceiptDollar = _IconReceiptDollar2.default;
exports.IconReceiptRegisterPrint = _IconReceiptRegisterPrint2.default;
exports.IconRedo = _IconRedo2.default;
exports.IconRemoveCircle = _IconRemoveCircle2.default;
exports.IconRemoveColumn = _IconRemoveColumn2.default;
exports.IconRemoveRow = _IconRemoveRow2.default;
exports.IconRemove = _IconRemove2.default;
exports.IconRightOfColumn = _IconRightOfColumn2.default;
exports.IconRoadSignBanned = _IconRoadSignBanned2.default;
exports.IconRuler = _IconRuler2.default;
exports.IconSearchStar = _IconSearchStar2.default;
exports.IconSearch = _IconSearch2.default;
exports.IconSettingsSlider = _IconSettingsSlider2.default;
exports.IconSettingsVertical = _IconSettingsVertical2.default;
exports.IconSettingsToggleHorizontal = _IconSettingsToggleHorizontal2.default;
exports.IconShareAlt = _IconShareAlt2.default;
exports.IconShipmentBox = _IconShipmentBox2.default;
exports.IconShipmentCash = _IconShipmentCash2.default;
exports.IconShipmentCheck = _IconShipmentCheck2.default;
exports.IconShipmentGive = _IconShipmentGive2.default;
exports.IconShipmentPackages = _IconShipmentPackages2.default;
exports.IconShipmentPlane = _IconShipmentPlane2.default;
exports.IconShipmentTruck = _IconShipmentTruck2.default;
exports.IconShirtPlain = _IconShirtPlain2.default;
exports.IconShipmentUploadAlt = _IconShipmentUploadAlt2.default;
exports.IconShop = _IconShop2.default;
exports.IconShoppingBasketAdd = _IconShoppingBasketAdd2.default;
exports.IconShoppingBasketAlt = _IconShoppingBasketAlt2.default;
exports.IconShoppingCartAlt = _IconShoppingCartAlt2.default;
exports.IconShoppingCartFull = _IconShoppingCartFull2.default;
exports.IconStartContract = _IconStartContract2.default;
exports.IconStartPriceList = _IconStartPriceList2.default;
exports.IconSmallFormatCategory = _IconSmallFormatCategory2.default;
exports.IconSynchronizeArrowClock = _IconSynchronizeArrowClock2.default;
exports.IconSynchronizeArrowsAlt = _IconSynchronizeArrowsAlt2.default;
exports.IconTagDollarAlt = _IconTagDollarAlt2.default;
exports.IconTapCheck = _IconTapCheck2.default;
exports.IconTaskListWarning = _IconTaskListWarning2.default;
exports.IconTextItalic = _IconTextItalic2.default;
exports.IconTextStrikeThrough = _IconTextStrikeThrough2.default;
exports.IconTextUnderline = _IconTextUnderline2.default;
exports.IconTextBold = _IconTextBold2.default;
exports.IconTimeClockCircle = _IconTimeClockCircle2.default;
exports.IconTimeStopwatch = _IconTimeStopwatch2.default;
exports.IconTopOfRow = _IconTopOfRow2.default;
exports.IconTruckCargo = _IconTruckCargo2.default;
exports.IconTruckConfigure = _IconTruckConfigure2.default;
exports.IconUndo = _IconUndo2.default;
exports.IconUploadBottom = _IconUploadBottom2.default;
exports.IconUserActionsRemove = _IconUserActionsRemove2.default;
exports.IconUserAlt = _IconUserAlt2.default;
exports.IconUserLock = _IconUserLock2.default;
exports.IconUserPhoneBook = _IconUserPhoneBook2.default;
exports.IconUserSetting = _IconUserSetting2.default;
exports.IconVectorsAnchorSquareAlt = _IconVectorsAnchorSquareAlt2.default;
exports.IconViewColumn = _IconViewColumn2.default;
exports.IconVideoPlayerMovieAlt = _IconVideoPlayerMovieAlt2.default;
exports.IconViewOff = _IconViewOff2.default;
exports.IconView = _IconView2.default;
exports.IconWarehousePackages = _IconWarehousePackages2.default;
exports.IconZoomIn = _IconZoomIn2.default;
exports.IconWarehouseCartPackage = _IconWarehouseCartPackage2.default;
exports.IconWarehouseCartPackages2 = _IconWarehouseCartPackages2.default;
exports.IconZoomOut = _IconZoomOut2.default;
exports.IconUser = _IconUser2.default;
exports.IconBookOpen = _IconBookOpen2.default;
exports.IconBookOpenBookmark = _IconBookOpenBookmark2.default;
exports.IconBooksCategory = _IconBooksCategory2.default;
exports.default = {
  IconAccountingCalculatorAlt: _IconAccountingCalculatorAlt2.default,
  IconAccountingCalculator: _IconAccountingCalculator2.default,
  IconAccountingCoinsBill: _IconAccountingCoinsBill2.default,
  IconAddCircle: _IconAddCircle2.default,
  IconAccountingDocument: _IconAccountingDocument2.default,
  IconAddProduct: _IconAddProduct2.default,
  IconAddSquare: _IconAddSquare2.default,
  IconAdd: _IconAdd2.default,
  IconAlarmBellOff: _IconAlarmBellOff2.default,
  IconAlertTriangle: _IconAlertTriangle2.default,
  IconAlarmBell: _IconAlarmBell2.default,
  IconAnalyticsGraph: _IconAnalyticsGraph2.default,
  IconAnalyticsPieAlt: _IconAnalyticsPieAlt2.default,
  IconAngleBrackets: _IconAngleBrackets2.default,
  IconAppWindowLayout: _IconAppWindowLayout2.default,
  IconAppWindowNext: _IconAppWindowNext2.default,
  IconAppWindowSearchAlt: _IconAppWindowSearchAlt2.default,
  IconArrowButtonDown2: _IconArrowButtonDown2.default,
  IconArrowButtonDown: _IconArrowButtonDown4.default,
  IconArrowButtonLeft2: _IconArrowButtonLeft2.default,
  IconArrowButtonLeft: _IconArrowButtonLeft4.default,
  IconArrowButtonRight2: _IconArrowButtonRight2.default,
  IconArrowButtonRight: _IconArrowButtonRight4.default,
  IconArrowButtonUp2: _IconArrowButtonUp2.default,
  IconArrowButtonUp: _IconArrowButtonUp4.default,
  IconArrowCircleDown: _IconArrowCircleDown2.default,
  IconArrowCircleLeft: _IconArrowCircleLeft2.default,
  IconArrowCircleRight: _IconArrowCircleRight2.default,
  IconArrowCircleUp: _IconArrowCircleUp2.default,
  IconApparelCategory: _IconApparelCategory2.default,
  IconArrowDownAlt: _IconArrowDownAlt2.default,
  IconArrowDown: _IconArrowDown2.default,
  IconArrowLeftAlt: _IconArrowLeftAlt2.default,
  IconArrowLeft: _IconArrowLeft2.default,
  IconArrowRightAlt: _IconArrowRightAlt2.default,
  IconArrowRight: _IconArrowRight2.default,
  IconArrowThickDown: _IconArrowThickDown2.default,
  IconArrowThickLeft: _IconArrowThickLeft2.default,
  IconArrowThickRight: _IconArrowThickRight2.default,
  IconArrowThickUp: _IconArrowThickUp2.default,
  IconArrowUpAlt: _IconArrowUpAlt2.default,
  IconArrowUp: _IconArrowUp2.default,
  IconArtboardShrink: _IconArtboardShrink2.default,
  IconAttachment: _IconAttachment2.default,
  IconBagsCategory: _IconBagsCategory2.default,
  IconBarcode: _IconBarcode2.default,
  IconBin: _IconBin2.default,
  IconBottomOfRow: _IconBottomOfRow2.default,
  IconBusinessContractHandshakeSign: _IconBusinessContractHandshakeSign2.default,
  IconBusinessDealCashExchange: _IconBusinessDealCashExchange2.default,
  IconButtonPause: _IconButtonPause2.default,
  IconButtonStop: _IconButtonStop2.default,
  IconCalendarHome: _IconCalendarHome2.default,
  IconCalendarPlane: _IconCalendarPlane2.default,
  IconCalendar: _IconCalendar2.default,
  IconCap2: _IconCap2.default,
  IconCashEye: _IconCashEye2.default,
  IconChargerAlt: _IconChargerAlt2.default,
  IconCheckBadge: _IconCheckBadge2.default,
  IconCheckCircleAlt: _IconCheckCircleAlt2.default,
  IconCheckSquare: _IconCheckSquare2.default,
  IconCheck: _IconCheck2.default,
  IconChecklist: _IconChecklist2.default,
  IconClose: _IconClose2.default,
  IconCloudUpload: _IconCloudUpload2.default,
  IconCogApproved: _IconCogApproved2.default,
  IconCogDouble: _IconCogDouble2.default,
  IconCog: _IconCog2.default,
  IconColorBucketAlt: _IconColorBucketAlt2.default,
  IconColorBucket: _IconColorBucket2.default,
  IconColorPaintingPalette: _IconColorPaintingPalette2.default,
  IconColorPicker3: _IconColorPicker2.default,
  IconCommonFileStack: _IconCommonFileStack2.default,
  IconCommonFileText: _IconCommonFileText2.default,
  IconCompare: _IconCompare2.default,
  IconCompassAlt: _IconCompassAlt2.default,
  IconConfigureTemplate: _IconConfigureTemplate2.default,
  IconControlsPlay: _IconControlsPlay2.default,
  IconConversationChatAlt: _IconConversationChatAlt2.default,
  IconCopyPaste: _IconCopyPaste2.default,
  IconCopy: _IconCopy2.default,
  IconCurrencyEuroDollarExchange: _IconCurrencyEuroDollarExchange2.default,
  IconDeliveryTruck2: _IconDeliveryTruck2.default,
  IconDeliveryTruckClock: _IconDeliveryTruckClock2.default,
  IconDesignToolPenStation: _IconDesignToolPenStation2.default,
  IconDesignWarpCylinder: _IconDesignWarpCylinder2.default,
  IconDesignWarpPerspective: _IconDesignWarpPerspective2.default,
  IconDesktopMonitorApprove: _IconDesktopMonitorApprove2.default,
  IconDirectionButtonArrows: _IconDirectionButtonArrows2.default,
  IconDiscount: _IconDiscount2.default,
  IconDownloadBottom: _IconDownloadBottom2.default,
  IconDragDrop: _IconDragDrop2.default,
  IconDataTransferHorizontal: _IconDataTransferHorizontal2.default,
  IconDeliveryParachute: _IconDeliveryParachute2.default,
  IconDeliveryTruckBoxes: _IconDeliveryTruckBoxes2.default,
  IconDragHorizontial: _IconDragHorizontial2.default,
  IconDragVertical: _IconDragVertical2.default,
  IconDrawerFile: _IconDrawerFile2.default,
  IconDrawerOpen: _IconDrawerOpen2.default,
  IconDrop: _IconDrop2.default,
  IconEarth3: _IconEarth2.default,
  IconEarthAlt: _IconEarthAlt2.default,
  IconEmailActionCash: _IconEmailActionCash2.default,
  IconEmailActionUnread: _IconEmailActionUnread2.default,
  IconEmailSend: _IconEmailSend2.default,
  IconExpand5: _IconExpand2.default,
  IconExpandDiagonal2: _IconExpandDiagonal2.default,
  IconFactory: _IconFactory2.default,
  IconFileCode: _IconFileCode2.default,
  IconFilterAlt: _IconFilterAlt2.default,
  IconFinalizeContract: _IconFinalizeContract2.default,
  IconFinalizePriceList: _IconFinalizePriceList2.default,
  IconFloppyDiskAlt: _IconFloppyDiskAlt2.default,
  IconFocusLandscape: _IconFocusLandscape2.default,
  IconFolderImage: _IconFolderImage2.default,
  IconFolderCode: _IconFolderCode2.default,
  IconFulfillerCreate: _IconFulfillerCreate2.default,
  IconGaugeDashboard: _IconGaugeDashboard2.default,
  IconGiftsCategory: _IconGiftsCategory2.default,
  IconGridGuides: _IconGridGuides2.default,
  IconHierarchyFlow: _IconHierarchyFlow2.default,
  IconHierarchyNode: _IconHierarchyNode2.default,
  IconHouse: _IconHouse2.default,
  IconHyperlink: _IconHyperlink2.default,
  IconIdCard: _IconIdCard2.default,
  IconImageFileAdd: _IconImageFileAdd2.default,
  IconImageFileEdit: _IconImageFileEdit2.default,
  IconImageFileSettings: _IconImageFileSettings2.default,
  IconInformationCircle: _IconInformationCircle2.default,
  IconIrisScanLock: _IconIrisScanLock2.default,
  IconLargeFormatCategory: _IconLargeFormatCategory2.default,
  IconLayersBack: _IconLayersBack2.default,
  IconLayersFront: _IconLayersFront2.default,
  IconLayoutDashboard: _IconLayoutDashboard2.default,
  IconLayers: _IconLayers2.default,
  IconLayoutModule: _IconLayoutModule2.default,
  IconLeftOfColumn: _IconLeftOfColumn2.default,
  IconListBullets: _IconListBullets2.default,
  IconLoadingCircleAlt: _IconLoadingCircleAlt2.default,
  IconLoadingHalf: _IconLoadingHalf2.default,
  IconLockAlt: _IconLockAlt2.default,
  IconLockUnlock: _IconLockUnlock2.default,
  IconMessagesBubbleInformation: _IconMessagesBubbleInformation2.default,
  IconMessagesBubbleQuestion: _IconMessagesBubbleQuestion2.default,
  IconMessagesBubble: _IconMessagesBubble2.default,
  IconMonitorShoppingCart: _IconMonitorShoppingCart2.default,
  IconMultipleActionsRemove: _IconMultipleActionsRemove2.default,
  IconMonitorAlt: _IconMonitorAlt2.default,
  IconMessagesPeopleUserDollar: _IconMessagesPeopleUserDollar2.default,
  IconNavigationMenuVertical: _IconNavigationMenuVertical2.default,
  IconNavigationMenu: _IconNavigationMenu2.default,
  IconMultipleUsers: _IconMultipleUsers2.default,
  IconNavigationNext: _IconNavigationNext2.default,
  IconNewspaper: _IconNewspaper2.default,
  IconNumeric: _IconNumeric2.default,
  IconNetworkPin: _IconNetworkPin2.default,
  IconOfficeFilePdf: _IconOfficeFilePdf2.default,
  IconOfficeFileXls: _IconOfficeFileXls2.default,
  IconPackageCategory: _IconPackageCategory2.default,
  IconParagraphCenterAlign: _IconParagraphCenterAlign2.default,
  IconParagraphLeftAlign: _IconParagraphLeftAlign2.default,
  IconParagraphRightAlign: _IconParagraphRightAlign2.default,
  IconPencilAlt: _IconPencilAlt2.default,
  IconPencilCircle: _IconPencilCircle2.default,
  IconPerformanceIncreaseAlt: _IconPerformanceIncreaseAlt2.default,
  IconPictureFlowerAlt: _IconPictureFlowerAlt2.default,
  IconPicturePolaroidAlbumAlt: _IconPicturePolaroidAlbumAlt2.default,
  IconPicturePolaroidLandscape: _IconPicturePolaroidLandscape2.default,
  IconPictureSun: _IconPictureSun2.default,
  IconPin: _IconPin2.default,
  IconPinLocationAlt: _IconPinLocationAlt2.default,
  IconPrintPicture: _IconPrintPicture2.default,
  IconProductPricingTerms: _IconProductPricingTerms2.default,
  IconProductsBriefcase: _IconProductsBriefcase2.default,
  IconPromoProductsCategory: _IconPromoProductsCategory2.default,
  IconQuestionCircle: _IconQuestionCircle2.default,
  IconQuoterRecommendations: _IconQuoterRecommendations2.default,
  IconQuoter: _IconQuoter2.default,
  IconRatingStar: _IconRatingStar2.default,
  IconRatingStarAlt: _IconRatingStarAlt2.default,
  IconReceiptDollar: _IconReceiptDollar2.default,
  IconReceiptRegisterPrint: _IconReceiptRegisterPrint2.default,
  IconRedo: _IconRedo2.default,
  IconRemoveCircle: _IconRemoveCircle2.default,
  IconRemoveColumn: _IconRemoveColumn2.default,
  IconRemoveRow: _IconRemoveRow2.default,
  IconRemove: _IconRemove2.default,
  IconRightOfColumn: _IconRightOfColumn2.default,
  IconRoadSignBanned: _IconRoadSignBanned2.default,
  IconRuler: _IconRuler2.default,
  IconSearchStar: _IconSearchStar2.default,
  IconSearch: _IconSearch2.default,
  IconSettingsSlider: _IconSettingsSlider2.default,
  IconSettingsVertical: _IconSettingsVertical2.default,
  IconSettingsToggleHorizontal: _IconSettingsToggleHorizontal2.default,
  IconShareAlt: _IconShareAlt2.default,
  IconShipmentBox: _IconShipmentBox2.default,
  IconShipmentCash: _IconShipmentCash2.default,
  IconShipmentCheck: _IconShipmentCheck2.default,
  IconShipmentGive: _IconShipmentGive2.default,
  IconShipmentPackages: _IconShipmentPackages2.default,
  IconShipmentPlane: _IconShipmentPlane2.default,
  IconShipmentTruck: _IconShipmentTruck2.default,
  IconShirtPlain: _IconShirtPlain2.default,
  IconShipmentUploadAlt: _IconShipmentUploadAlt2.default,
  IconShop: _IconShop2.default,
  IconShoppingBasketAdd: _IconShoppingBasketAdd2.default,
  IconShoppingBasketAlt: _IconShoppingBasketAlt2.default,
  IconShoppingCartAlt: _IconShoppingCartAlt2.default,
  IconShoppingCartFull: _IconShoppingCartFull2.default,
  IconStartContract: _IconStartContract2.default,
  IconStartPriceList: _IconStartPriceList2.default,
  IconSmallFormatCategory: _IconSmallFormatCategory2.default,
  IconSynchronizeArrowClock: _IconSynchronizeArrowClock2.default,
  IconSynchronizeArrowsAlt: _IconSynchronizeArrowsAlt2.default,
  IconTagDollarAlt: _IconTagDollarAlt2.default,
  IconTapCheck: _IconTapCheck2.default,
  IconTaskListWarning: _IconTaskListWarning2.default,
  IconTextItalic: _IconTextItalic2.default,
  IconTextStrikeThrough: _IconTextStrikeThrough2.default,
  IconTextUnderline: _IconTextUnderline2.default,
  IconTextBold: _IconTextBold2.default,
  IconTimeClockCircle: _IconTimeClockCircle2.default,
  IconTimeStopwatch: _IconTimeStopwatch2.default,
  IconTopOfRow: _IconTopOfRow2.default,
  IconTruckCargo: _IconTruckCargo2.default,
  IconTruckConfigure: _IconTruckConfigure2.default,
  IconUndo: _IconUndo2.default,
  IconUploadBottom: _IconUploadBottom2.default,
  IconUserActionsRemove: _IconUserActionsRemove2.default,
  IconUserAlt: _IconUserAlt2.default,
  IconUserLock: _IconUserLock2.default,
  IconUserPhoneBook: _IconUserPhoneBook2.default,
  IconUserSetting: _IconUserSetting2.default,
  IconVectorsAnchorSquareAlt: _IconVectorsAnchorSquareAlt2.default,
  IconViewColumn: _IconViewColumn2.default,
  IconVideoPlayerMovieAlt: _IconVideoPlayerMovieAlt2.default,
  IconViewOff: _IconViewOff2.default,
  IconView: _IconView2.default,
  IconWarehousePackages: _IconWarehousePackages2.default,
  IconZoomIn: _IconZoomIn2.default,
  IconWarehouseCartPackage: _IconWarehouseCartPackage2.default,
  IconWarehouseCartPackages2: _IconWarehouseCartPackages2.default,
  IconZoomOut: _IconZoomOut2.default,
  IconUser: _IconUser2.default,
  IconBookOpen: _IconBookOpen2.default,
  IconBookOpenBookmark: _IconBookOpenBookmark2.default,
  IconBooksCategory: _IconBooksCategory2.default
};